import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import linkedIn from "../../assets/linkedInIcon.png";
import Cookies from 'js-cookie';

function LinkedInProfile({setActiveIndicator, linkedInURL, setLinkedInURL, cvFile, mLetterfile, linkedInData, setLinkedInData}) {
  const navigate = useNavigate();
  const location = useLocation();
  
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const validateLinkedInURL = (url) => {
    try {
      const urlObj = new URL(url);
      return urlObj.hostname.includes('linkedin.com');
    } catch {
      return false;
    }
  };

  const handleSubmit = async (event) => {
    setIsLoading(true);
    if (!linkedInURL) {
      setError("Please enter a LinkedIn URL");
      return;
    }
    
    if (!validateLinkedInURL(linkedInURL)) {
      setError("Please enter a valid LinkedIn URL");
      return;
    }
    

    try {
      event.preventDefault();
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/data`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Cookies.get('token')}`
        },
        body: JSON.stringify({ url: linkedInURL }),
      });
      const data = await response.json();
      setLinkedInData(data.data);

      navigate("/analysis", {
        state: {
          cvFile,
          mLetterfile,
          linkedInURL,
          linkedInData
        }
      });
      setError("");
      setActiveIndicator(3);
      } catch (error) {
        console.error('Error:', error);
        setError('An error occurred. Please try again later.');
      } finally {
        setIsLoading(false);
      }
  };

  const HandleBack = () => {
    setActiveIndicator(2);
  };

    return (
      <div>
        <div className='mb-4'>
          <h1 className="text-5xl font-bold mb-4">LinkedIn Profile</h1>
          <p>Enter LinkedIn Profile Url</p>
        </div>
        <div className="border rounded-md p-6">
          <h3 className="text-left mb-4 text-xl font-bold">LinkedIn Profile</h3>
          <span className="flex gap-2 rounded-md items-center">
            <img src={linkedIn} className="h-10 flex" alt="LinkedIn icon"/>
            <input 
              type="text" 
              placeholder="Enter URL"
              value={linkedInURL}
              onChange={(e) => {
                setLinkedInURL(e.target.value);
                setError("");
              }}
              className={`w-full py-2 border-bottom ${error ? 'border-red-500' : ''}`}
            />
          </span>
          {error && <p className="text-red-500 mt-2">{error}</p>}
        </div>

        <div className="flex gap-2 mt-4 justify-end">
          <button
            className="py-2 px-4 rounded-md border"
            onClick={HandleBack}
          >
            Back
          </button>
          <button
            className="py-2 px-4 rounded-md bg-default text-white border"
            onClick={handleSubmit}
            disabled={isLoading}
          >
            {isLoading ? 'Analyzing LinkedIn Profile...' : 'Start Analysis'}
          </button>
        </div>
      </div>
    );
  }
  
  export default LinkedInProfile;